import { css } from "@emotion/core";

export const OverviewStyles = css({});
